define('presentation/common/routeToModal/presentationObjects/liveReceptionistScriptPresentationObject',[],function() {
    return function(){
        var self = this;
        self.liveReceptionistScriptId = null;
        self.name = null;
        self.status = null;
    };
});

